/* eslint-disable react/prop-types */
import { DreamBlock } from '@typedream/core';
import { createTPluginFactory } from '../../plate';
import { KEY_BADGES } from '../../pluginKeys';
import { Badges } from './components/Badges';

export const createBadgesPlugin = createTPluginFactory({
  key: KEY_BADGES,
  inject: {
    belowComponent: () => (function InjectElementBadges(props) {
      const { element, children } = props;

      return (
        <>
          {children}
          <Badges element={element as DreamBlock} />
        </>
      );
    }),
  },
});
